var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-sheet",
    { ref: "wrapper", staticClass: "fill-height d-flex flex-column" },
    [
      _c("h2", { staticClass: "page-title page-title__primary" }, [
        _vm._v("Скважины"),
      ]),
      _c("p", [_vm._v("Данные берутся из секций WELSPECS и COMPDAT")]),
      _c(
        "div",
        {
          staticClass: "grid-wrapper",
          style: { marginRight: _vm.sidebarWidth + "px" },
        },
        [_vm._t("grid", null, { wc: this })],
        2
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "650px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c("well-edit", {
            attrs: {
              reservoir: _vm.reservoir,
              wells: _vm.wells,
              nodes: _vm.nodes,
              connections: _vm.connections,
              grid: _vm.gridProperties,
              "input-constants": _vm.inputConstants,
              "recalc-loading": _vm.recalcLoading,
            },
            on: {
              "input-connections": _vm.setUpdatedConnections,
              delete: _vm.deleteEditedWell,
              recalc: _vm.fillWell,
              save: _vm.save,
              close: _vm.close,
            },
            model: {
              value: _vm.editedItem,
              callback: function ($$v) {
                _vm.editedItem = $$v
              },
              expression: "editedItem",
            },
          }),
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "mb-4",
          attrs: {
            absolute: "",
            permanent: "",
            right: "",
            width: _vm.sidebarWidth,
          },
        },
        [
          _c("v-data-table", {
            staticClass: "wells-table",
            attrs: {
              headers: _vm.headers,
              items: _vm.wells,
              width: "100%",
              options: { itemsPerPage: -1 },
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u([
              {
                key: "header.actions",
                fn: function () {
                  return [
                    _c(
                      "v-menu",
                      {
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      { attrs: { icon: "" } },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("mdi-cog")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c(
                          "v-list",
                          _vm._l(_vm.extraHeaders, function (header) {
                            return _c(
                              "v-list-item",
                              { key: header.value },
                              [
                                _c(
                                  "v-list-item-action",
                                  [
                                    _c("v-checkbox", {
                                      model: {
                                        value: _vm.activeHeaders[header.value],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.activeHeaders,
                                            header.value,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "activeHeaders[header.value]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(header.text)),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "item.imaginary",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _vm._v(
                      " " + _vm._s(item.imaginary ? "Мнимая" : "Нет") + " "
                    ),
                  ]
                },
              },
              {
                key: "item.perf_z",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.nodes
                            .map(function (node) {
                              return node.z_coord_relative
                            })
                            .join(", ")
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.perf_p",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.nodes
                            .map(function (node) {
                              return node.p_pressure
                            })
                            .join(", ")
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.perf_sw",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.nodes
                            .map(function (node) {
                              return node.sw_water_saturation
                            })
                            .join(", ")
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.connections",
                fn: function (ref) {
                  var item = ref.item
                  return _vm._l(_vm.getAllConnections(item), function (conn) {
                    return _c("div", {
                      key: conn.value,
                      domProps: {
                        innerHTML: _vm._s(conn.text.replace(" ", "&nbsp;")),
                      },
                    })
                  })
                },
              },
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-nowrap" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("active", item.id)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-eye")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                return _vm.editWell(item)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-pencil")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteWell(item)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }